import {
    getCustomDateTime,
    getTodayTime,
    getTomorrowTime,
    isTodayDay,
    isTomorrowDay,
} from 'helpers/datetime'
import { ALL_BATTLES_NEXT_PRIMETIME } from './translations'
import { getClosestPrimetimeStart } from 'helpers/schedule'

export function getNextBattleMessage(playdays, playdayStart, playdayEnd, unitType, currentHour) {
    const closestPrimetimeStart = getClosestPrimetimeStart(
        playdays, playdayStart, playdayEnd, unitType, currentHour
    )
    if (!closestPrimetimeStart) return ''
    if (isTodayDay(closestPrimetimeStart.local())) {
        return ALL_BATTLES_NEXT_PRIMETIME(getTodayTime(closestPrimetimeStart))
    }
    if (isTomorrowDay(closestPrimetimeStart.local())) {
        return ALL_BATTLES_NEXT_PRIMETIME(getTomorrowTime(closestPrimetimeStart))
    }
    return ALL_BATTLES_NEXT_PRIMETIME(getCustomDateTime(closestPrimetimeStart))
}



// WEBPACK FOOTER //
// ./containers/Schedule/components/NoBattlesMessage/helpers.js